export const PLAYER_BIOME_X_GRACE = 500

export const worldStringTable: string[] = []
worldStringTable.push('grass_01')
worldStringTable.push('grass_02')
worldStringTable.push('sand_01')
worldStringTable.push('sand_02')
worldStringTable.push('sand_03')
worldStringTable.push('sand_rare_01')
